module.exports = __webpack_public_path__ + "img/banner.b2118323.jpg";